import { useInstancesByQuery } from 'hive-react-utils';
import _ from 'lodash';
import { useMemo } from 'react';
export function useLatestSurvey() {
    const surveys = useInstancesByQuery('ecarepd_survey', 'latestSurvey', 'survey', {});
    return useMemo(() => _.first(surveys), [surveys]);
}
